<template>
  <v-file-input
    :rules="rules"
    :label="label"
    :accept="accept"
    v-model="selectedFile"
    @change="onFileChange"
    @click:clear="onFileClear"
    density="compact"
    prepend-icon="mdi-camera"
    :show-size="true"
    :clearable="true"
  ></v-file-input>
</template>

<script>
export default {
  props: {
    rules: {
      type: Array,
      default: () => [
        (value) => {
          if (value && value.length) return true;
          return "No file uploaded";
        },
        (value) => {
          if (value[0].size < 2000000) return true;
          return "File size should be less than 20 MB!";
        },
      ],
    },
    imgRef: { type: String, required: true },
    label: String,
    accept: String,
  },
  data() {
    return {
      selectedFile: null,
      fileBlob: null,
      imageSrc: null,
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onFileChange(e) {
      if (!this.selectedFile || this.selectedFile.length === 0) {
        this.imageSrc = null;
        this.$emit("file-changed", {
          ref: this.imgRef,
          fileBlob: null,
          imageSrc: null,
          file: null,
        });
        return;
      }
      this.fileBlob = this.selectedFile[0];
      var file_to_relay = e.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        this.imageSrc = e.target.result;
        this.$emit("file-changed", {
          ref: this.imgRef,
          fileBlob: this.fileBlob,
          imageSrc: this.imageSrc,
          file: file_to_relay,
        });
      };
      reader.readAsDataURL(this.fileBlob);
    },
    onFileClear() {
      this.imageSrc = null;
      this.$emit("file-changed", {
        ref: this.imgRef,
        fileBlob: null,
        imageSrc: null,
      });
    },
  },
};
</script>
